var map = {
	"./logo-1.png": "3154",
	"./logo-2.png": "c4a8",
	"./logo-3.png": "7eba",
	"./logo-4.png": "2c4b",
	"./logo-5.png": "f31e",
	"./logo-6.png": "ea57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7dd";